import React from 'react';
import { useSubscriptionExpiryToast } from '../hooks/use-subscription-expiry-toast';

/**
 * Рендерит null: нужен только чтобы повесить эффект на дерево лэйаута.
 * Той же идиоме следует <JivoChatLoader />.
 */
const SubscriptionExpiryNotifier = React.memo(function SubscriptionExpiryNotifier() {
  useSubscriptionExpiryToast();
  return null;
});

export default SubscriptionExpiryNotifier;
